import React, { useContext } from "react";
import { PaymentFooter } from "get-life-storybook-ts";
import { I18nContext } from "../../context/i18n.context";
import { DOMAIN } from "../../constants/Global";
import { GlobalShowTruspilot } from "../../utils/InternationlChanges";
import { LanguageT } from "../../context/GetLifeContext.context";
import "./NativeShellFooter.scss";

/**
 * Pie legal del marco propio native (Dashboard, funnel): el PaymentFooter de
 * siempre, pero dentro de la columna del marco (--shell-width) y sobre su fondo.
 */
const NativeShellFooter = () => {
  const {
    state: { translate },
  } = useContext(I18nContext);
  return (
    <div className="nativeShellFooter">
      <PaymentFooter
        text={translate("paymentFooter.text")}
        showTrustPilot={GlobalShowTruspilot[DOMAIN as LanguageT]}
      />
    </div>
  );
};

export default NativeShellFooter;
